import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGripVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.875 0.625H1.125C0.632812 0.625 0.25 1.03516 0.25 1.5V3.25C0.25 3.74219 0.632812 4.125 1.125 4.125H2.875C3.33984 4.125 3.75 3.74219 3.75 3.25V1.5C3.75 1.03516 3.33984 0.625 2.875 0.625ZM2.875 5H1.125C0.632812 5 0.25 5.41016 0.25 5.875V7.625C0.25 8.11719 0.632812 8.5 1.125 8.5H2.875C3.33984 8.5 3.75 8.11719 3.75 7.625V5.875C3.75 5.41016 3.33984 5 2.875 5ZM2.875 9.375H1.125C0.632812 9.375 0.25 9.78516 0.25 10.25V12C0.25 12.4922 0.632812 12.875 1.125 12.875H2.875C3.33984 12.875 3.75 12.4922 3.75 12V10.25C3.75 9.78516 3.33984 9.375 2.875 9.375ZM8.125 0.625H6.375C5.88281 0.625 5.5 1.03516 5.5 1.5V3.25C5.5 3.74219 5.88281 4.125 6.375 4.125H8.125C8.58984 4.125 9 3.74219 9 3.25V1.5C9 1.03516 8.58984 0.625 8.125 0.625ZM8.125 5H6.375C5.88281 5 5.5 5.41016 5.5 5.875V7.625C5.5 8.11719 5.88281 8.5 6.375 8.5H8.125C8.58984 8.5 9 8.11719 9 7.625V5.875C9 5.41016 8.58984 5 8.125 5ZM8.125 9.375H6.375C5.88281 9.375 5.5 9.78516 5.5 10.25V12C5.5 12.4922 5.88281 12.875 6.375 12.875H8.125C8.58984 12.875 9 12.4922 9 12V10.25C9 9.78516 8.58984 9.375 8.125 9.375Z",
		fill: "#B0BEC5"
	})]
});
const ForwardRef = forwardRef(SvgGripVertical);
export { ForwardRef as ReactComponent };
